var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#5260FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8336 15.668V16.3346C25.8336 16.7028 25.5352 17.0013 25.167 17.0013H17.5003V24.668C17.5003 25.0361 17.2018 25.3346 16.8336 25.3346H16.167C15.7988 25.3346 15.5003 25.0361 15.5003 24.668V17.0013H7.83366C7.46547 17.0013 7.16699 16.7028 7.16699 16.3346V15.668C7.16699 15.2998 7.46547 15.0013 7.83366 15.0013H15.5003V7.33463C15.5003 6.96644 15.7988 6.66797 16.167 6.66797H16.8336C17.2018 6.66797 17.5003 6.96644 17.5003 7.33463V15.0013H25.167C25.5352 15.0013 25.8336 15.2998 25.8336 15.668Z",
    fill: "#5260FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.df40eedcfc540337970d9762761cf21e.svg";
export { ForwardRef as ReactComponent };